export default __webpack_public_path__ + "static/media/JobTwo1.5ea1db18.jpg";